import update from 'immutability-helper';

import { REQUEST_INPROGRESS, REQUEST_SUCCESS, REQUEST_ERROR } from 'store/constants';

import {
  SET_CROSSSELL_ACTIVE_ID,
  CLEAR_CROSSSELL_ACTIVE_ID,
  REQUEST_CROSSSELL_DETAILS,
  REQUEST_CROSSSELL_DETAILS_DONE,
  REQUEST_CROSSSELL_DETAILS_ERROR,
  REQUEST_CROSSSELL_TRACK_OPEN,
  REQUEST_CROSSSELL_TRACK_ACTIVATION,
  UPDATE_CROSSSELL_CATEGORY_LIST,
  SET_CROSSSELL_COUNT_TO_SHOW,
} from './constants';

const initialState = {
  activeProductId: null,
  /*
  list: [{
    requestStatus: null,
    details: null,
  },...],
  */
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CROSSSELL_ACTIVE_ID: {
      const { productId } = action;
      return {
        ...state,
        activeProductId: productId,
      };
    }
    case CLEAR_CROSSSELL_ACTIVE_ID: {
      return {
        ...state,
        activeProductId: null,
      };
    }
    case REQUEST_CROSSSELL_TRACK_OPEN:
    case REQUEST_CROSSSELL_TRACK_ACTIVATION: {
      return state;
    }
    case REQUEST_CROSSSELL_DETAILS: {
      const { productId } = action;
      const index = state.list.findIndex(({ shopProductId }) => shopProductId === productId);
      return update(state, {
        list: {
          [index]: {
            requestStatus: { $set: REQUEST_INPROGRESS },
          },
        },
      });
    }
    case REQUEST_CROSSSELL_DETAILS_DONE: {
      const { productId, details } = action;
      const index = state.list.findIndex(({ shopProductId }) => shopProductId === productId);
      return update(state, {
        list: {
          [index]: {
            $merge: {
              ...details,
              badges: [],
              requestStatus: REQUEST_SUCCESS,
            },
          },
        },
      });
    }
    case REQUEST_CROSSSELL_DETAILS_ERROR: {
      const { productId, message } = action;

      const index = state.list.findIndex(({ shopProductId }) => shopProductId === productId);
      return update(state, {
        list: {
          [index]: {
            requestStatus: { $set: REQUEST_ERROR },
            error: { $set: message },
          },
        },
      });
    }
    case UPDATE_CROSSSELL_CATEGORY_LIST: {
      const categorys = state.categorys || [];
      const activeCategorySlug = action.payload;
      const actualCategorys = categorys.map((category) => {
        if (category.text === activeCategorySlug) {
          category.active = true;
        } else {
          category.active = false;
        }
        return category;
      });
      return {
        ...state,
        categorys: actualCategorys,
      };
    }
    case SET_CROSSSELL_COUNT_TO_SHOW: {
      const { countToShowDesktop, countToShowMobile } = action.payload;
      return {
        ...state,
        countToShowDesktop,
        countToShowMobile,
      };
    }
    default:
      return state;
  }
}
